module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-bb.97491532.png";